/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import type { DiscountBXGY } from './DiscountBXGY';
// @ts-ignore
import {
// @ts-ignore
    instanceOfDiscountBXGY,
// @ts-ignore
    DiscountBXGYFromJSON,
// @ts-ignore
    DiscountBXGYFromJSONTyped,
// @ts-ignore
    DiscountBXGYToJSON,
} from './DiscountBXGY';
// @ts-ignore
import type { DiscountFixedAmount } from './DiscountFixedAmount';
// @ts-ignore
import {
// @ts-ignore
    instanceOfDiscountFixedAmount,
// @ts-ignore
    DiscountFixedAmountFromJSON,
// @ts-ignore
    DiscountFixedAmountFromJSONTyped,
// @ts-ignore
    DiscountFixedAmountToJSON,
} from './DiscountFixedAmount';
// @ts-ignore
import type { DiscountPercentage } from './DiscountPercentage';
// @ts-ignore
import {
// @ts-ignore
    instanceOfDiscountPercentage,
// @ts-ignore
    DiscountPercentageFromJSON,
// @ts-ignore
    DiscountPercentageFromJSONTyped,
// @ts-ignore
    DiscountPercentageToJSON,
} from './DiscountPercentage';

/**
 * @type Discount
 * 
 * @export
 */
export type Discount = { discountType: 'bxgy' } & DiscountBXGY | { discountType: 'fixed_amount' } & DiscountFixedAmount | { discountType: 'percentage' } & DiscountPercentage;

// @ts-ignore
export function DiscountFromJSON(json: any): Discount {
    return DiscountFromJSONTyped(json, false);
}

// @ts-ignore
export function DiscountFromJSONTyped(json: any, ignoreDiscriminator: boolean): Discount {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['discount_type']) {
        case 'bxgy':
            return {...DiscountBXGYFromJSONTyped(json, true), discountType: 'bxgy'};
        case 'fixed_amount':
            return {...DiscountFixedAmountFromJSONTyped(json, true), discountType: 'fixed_amount'};
        case 'percentage':
            return {...DiscountPercentageFromJSONTyped(json, true), discountType: 'percentage'};
        default:
            throw new Error(`No variant of Discount exists with 'discountType=${json['discountType']}'`);
    }
}

// @ts-ignore
export function DiscountToJSON(value?: Discount | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['discountType']) {
        case 'bxgy':
            return DiscountBXGYToJSON(value);
        case 'fixed_amount':
            return DiscountFixedAmountToJSON(value);
        case 'percentage':
            return DiscountPercentageToJSON(value);
        default:
            throw new Error(`No variant of Discount exists with 'discountType=${value['discountType']}'`);
    }

}

